 
import log from 'loglevel';
import { getAuthenticatedClient } from "../auth/authClient";

var graph = require('@microsoft/microsoft-graph-client');


 /* 
 * @param {*} chatId 
 * @param {*} accessToken 
 * @param {*} dispatch 
 */
export const getChatMessagesAndDispatch = async (chatId, accessToken, dispatch) =>{

  log.info(` getChatMessagesAndDispatch @ chatMessageService`);
  log.debug(`getChatMessagesAndDispatch @ chatMessageService accessToken: ${accessToken}`);

  const chatMessegesUrl = `/chats/${chatId}/messages`;
    
     
  const client = getAuthenticatedClient(accessToken);
    
  try {

   const res = await client
            .api(chatMessegesUrl)
            .headers({
              "Content-Type" : "application/json;charset=UTF-8",
               "mode": "cors",
              "Access-Control-Allow-Origin" : '' 
            })
            .version('beta')
            .get((error, chatMessages, rawResponse) => {

                  let someChatMessages =    chatMessages.value.filter(chatMessage =>{                         
                    if (chatMessage.body.content.length > 0 ) return true;
                    return false;
                  });

                  let __items = [];
                  someChatMessages.forEach(chatMessage => {
                    let _chatMessage = 
                    {
                      id :  chatMessage.id,
                      date: chatMessage.createdDateTime ? chatMessage.createdDateTime : 'not available',
                      text : `[ChatMessage:]${chatMessage.body.content.trim().replace( /(<([^>]+)>)/ig, '')}`,
                      webUrl : ``,
                      user : chatMessage.from.user.displayName,
                      type : "Message",
                      selected : true
                    };
                    __items.push(_chatMessage);
                    }
                  );
                  const __itemsReversed = [...__items];//.reverse();  !!!!
                  dispatch({ type: "ADD_MESSAGES", payload: __itemsReversed });
              }//get
           )//get
          } catch (error) {
            log.error(`error / getChatMessagesAndDispatch @chatMessageService ${JSON.stringify(error)}`);
        } finally {
            log.info(`finally / getChatMessagesAndDispatch @chatMessageService`);
        }          
}
 